import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { ThemesCrudService } from '../../shared/services/themes/themes-crud.service.ts';
import { SelectedThemeService } from '../../shared/services/themes/selected-theme.service.ts';
import { Button, ButtonDirective, ButtonIcon } from 'primeng/button';
import { ConfirmationService, MenuItem, PrimeIcons } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { confirm, showAlertDialog } from '@tokenbox/utils';
import { NavigateToService } from '../../shared/utils/navigate-to.service';
import { ThemeId } from '@tokenbox/domain';

@Component({
  selector: 'dt-themes-overview',
  imports: [RouterLink, ButtonDirective, ButtonIcon, Button, Menu],
  templateUrl: './themes-overview.component.html',
  styleUrl: './themes-overview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemesOverviewComponent {
  protected readonly PrimeIcons = PrimeIcons;
  private themesCrudService = inject(ThemesCrudService);
  private selectedThemeService = inject(SelectedThemeService);
  private confirmationService = inject(ConfirmationService);
  private navigateTo = inject(NavigateToService);

  allThemesGroupedByBrand = computed(() => {
    return this.themesCrudService
      .allThemesGroupedByBrand()
      .map(({ brandName, themes }) => ({
        brandName,
        themes: themes.map((theme) => ({
          ...theme,
          isSelected: theme.id === this.selectedThemeId(),
          menuItems: [
            {
              label: 'Edit...',
              icon: PrimeIcons.PENCIL,
              routerLink: ['design-tokens', 'themes', theme.id, 'edit'],
            },
            {
              separator: true,
            },
            {
              label: 'Delete',
              icon: PrimeIcons.TRASH,
              command: () => this.deleteTheme(theme.id),
            },
          ] satisfies MenuItem[],
        })),
      }));
  });
  selectedThemeId = this.selectedThemeService.selectedThemeId;

  async deleteTheme(themeId: ThemeId) {
    if (this.themesCrudService.allThemes().length <= 1) {
      await showAlertDialog(this.confirmationService)(
        'Cannot delete the only theme in a workspace',
        'Please create a new theme first.',
      );
      return;
    }
    if (
      await confirm(this.confirmationService)('Really delete this theme?', '')
    ) {
      await this.themesCrudService.deleteTheme(themeId);
      void this.navigateTo.currentWorkspace.designTokensPage();
    }
  }
}
